import * as NOTES_STRINGS from "./notes";

// eslint-disable-next-line import/prefer-default-export
export { NOTES_STRINGS };



// WEBPACK FOOTER //
// ./src/stringConstants/index.js